import type { ReactNode } from "react";
import { lacquer } from "../../common/common.css.ts";

export function Emphasis(props: { children: ReactNode }) {
  return <em className={lacquer}>{props.children}</em>;
}
